export default "__VITE_ASSET__51229d00__"